/* eslint-disable @typescript-eslint/no-explicit-any */
import { RentCatalogQuery } from '@/lib/entities/rent/model';

const defaultFilter = <T>([,]: [keyof T, T[keyof T]]) => {
  return true;
};
const defaultMap = <T extends [string, any]>([key, value]: T): T => {
  return [key, value] as T;
};

export const getSortedQueryParams = <
  T extends Partial<RentCatalogQuery>,
  _K extends [keyof T, T[keyof T]],
>(
  params: Partial<T> = {},
  filterFn: any = defaultFilter,
  mapFn: typeof defaultMap = defaultMap
) => {
  if (!params || Object.keys(params).length === 0) {
    return '';
  }
  const a = Object.entries(params)
    .filter(filterFn)
    .map(mapFn)
    .sort(([key1], [key2]) => key1.localeCompare(key2));

  return new URLSearchParams(Object.fromEntries(a) as any).toString();
};
